var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightSmall = function SvgArrowRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.707 7.293a1 1 0 0 1 0 1.414l-6.364 6.364a1 1 0 0 1-1.414-1.414L26.586 8l-5.657-5.657A1 1 0 0 1 22.343.93l6.364 6.364ZM28 9H0V7h28v2Z",
    fill: "#D0D5DD"
  })));
};
export default SvgArrowRightSmall;